"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeContent = exports.emptyProposal = exports.ProposalTypes = void 0;
const CarbonSDK_1 = require("../CarbonSDK");
const distribution_1 = require("../codec/cosmos/distribution/v1beta1/distribution");
const gov_1 = require("../codec/cosmos/gov/v1beta1/gov");
const params_1 = require("../codec/cosmos/params/v1beta1/params");
const upgrade_1 = require("../codec/cosmos/upgrade/v1beta1/upgrade");
const client_1 = require("../codec/ibc/core/client/v1/client");
var ProposalTypes;
(function (ProposalTypes) {
    ProposalTypes["ParameterChange"] = "/cosmos.params.v1beta1.ParameterChangeProposal";
    ProposalTypes["SoftwareUpgrade"] = "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal";
    ProposalTypes["CancelSoftwareUpgrade"] = "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal";
    ProposalTypes["CommunityPoolSpend"] = "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal";
    ProposalTypes["Text"] = "/cosmos.gov.v1beta1.TextProposal";
    ProposalTypes["SetMsgGasCost"] = "/Switcheo.carbon.fee.SetMsgGasCostProposal";
    ProposalTypes["SetMinGasPrice"] = "/Switcheo.carbon.fee.SetMinGasPriceProposal";
    ProposalTypes["RemoveMsgGasCost"] = "/Switcheo.carbon.fee.RemoveMsgGasCostProposal";
    ProposalTypes["RemoveMinGasPrice"] = "/Switcheo.carbon.fee.RemoveMinGasPriceProposal";
    ProposalTypes["CreateToken"] = "/Switcheo.carbon.coin.CreateTokenProposal";
    ProposalTypes["CreateOracle"] = "/Switcheo.carbon.oracle.CreateOracleProposal";
    ProposalTypes["UpdatePool"] = "/Switcheo.carbon.liquiditypool.UpdatePoolProposal";
    ProposalTypes["SetRewardCurve"] = "/Switcheo.carbon.liquiditypool.SetRewardCurveProposal";
    ProposalTypes["SetRewardsWeights"] = "/Switcheo.carbon.liquiditypool.SetRewardsWeightsProposal";
    ProposalTypes["SetCommitmentCurve"] = "/Switcheo.carbon.liquiditypool.SetCommitmentCurveProposal";
    ProposalTypes["UpdateMarket"] = "/Switcheo.carbon.market.UpdateMarketProposal";
    ProposalTypes["SettlementPrice"] = "/Switcheo.carbon.pricing.SettlementPriceProposal";
    ProposalTypes["ClientUpdateProposal"] = "/ibc.core.client.v1.ClientUpdateProposal";
    ProposalTypes["CreateGroup"] = "/Switcheo.carbon.coin.CreateGroupProposal";
    ProposalTypes["UpdateGroup"] = "/Switcheo.carbon.coin.UpdateGroupProposal";
    ProposalTypes["RegisterToGroup"] = "/Switcheo.carbon.coin.RegisterToGroupProposal";
    ProposalTypes["DeregisterFromGroup"] = "/Switcheo.carbon.coin.DeregisterFromGroupProposal";
    ProposalTypes["DepositToGroup"] = "/Switcheo.carbon.coin.DepositToGroupProposal";
    ProposalTypes["WithdrawFromGroup"] = "/Switcheo.carbon.coin.WithdrawFromGroupProposal";
    ProposalTypes["UpdateGroupTokenConfig"] = "/Switcheo.carbon.coin.UpdateGroupTokenConfigProposal";
    ProposalTypes["CreateAlliance"] = "/alliance.alliance.MsgCreateAllianceProposal";
    ProposalTypes["UpdateAlliance"] = "/alliance.alliance.MsgUpdateAllianceProposal";
    ProposalTypes["DeleteAlliance"] = "/alliance.alliance.MsgDeleteAllianceProposal";
})(ProposalTypes = exports.ProposalTypes || (exports.ProposalTypes = {}));
exports.emptyProposal = {
    typeUrl: "",
    value: {},
};
const decodeContent = (content) => {
    if (!content) {
        return exports.emptyProposal;
    }
    switch (content.typeUrl) {
        case ProposalTypes.ParameterChange:
            return Object.assign(Object.assign({}, content), { value: params_1.ParameterChangeProposal.decode(content.value) });
        case ProposalTypes.SoftwareUpgrade:
            return Object.assign(Object.assign({}, content), { value: upgrade_1.SoftwareUpgradeProposal.decode(content.value) });
        case ProposalTypes.CancelSoftwareUpgrade:
            return Object.assign(Object.assign({}, content), { value: upgrade_1.CancelSoftwareUpgradeProposal.decode(content.value) });
        case ProposalTypes.CommunityPoolSpend:
            return Object.assign(Object.assign({}, content), { value: distribution_1.CommunityPoolSpendProposal.decode(content.value) });
        case ProposalTypes.Text:
            return Object.assign(Object.assign({}, content), { value: gov_1.TextProposal.decode(content.value) });
        case ProposalTypes.UpdatePool:
            return Object.assign(Object.assign({}, content), { value: CarbonSDK_1.Carbon.Liquiditypool.UpdatePoolProposal.decode(content.value) });
        case ProposalTypes.CreateOracle:
            return Object.assign(Object.assign({}, content), { value: CarbonSDK_1.Carbon.Oracle.CreateOracleProposal.decode(content.value) });
        case ProposalTypes.CreateToken:
            return Object.assign(Object.assign({}, content), { value: CarbonSDK_1.Carbon.Coin.CreateTokenProposal.decode(content.value) });
        case ProposalTypes.SetCommitmentCurve:
            return Object.assign(Object.assign({}, content), { value: CarbonSDK_1.Carbon.Liquiditypool.SetCommitmentCurveProposal.decode(content.value) });
        case ProposalTypes.SetMsgGasCost:
            return Object.assign(Object.assign({}, content), { value: CarbonSDK_1.Carbon.Fee.SetMsgGasCostProposal.decode(content.value) });
        case ProposalTypes.SetMinGasPrice:
            return Object.assign(Object.assign({}, content), { value: CarbonSDK_1.Carbon.Fee.SetMinGasPriceProposal.decode(content.value) });
        case ProposalTypes.RemoveMsgGasCost:
            return Object.assign(Object.assign({}, content), { value: CarbonSDK_1.Carbon.Fee.RemoveMsgGasCostProposal.decode(content.value) });
        case ProposalTypes.RemoveMinGasPrice:
            return Object.assign(Object.assign({}, content), { value: CarbonSDK_1.Carbon.Fee.RemoveMinGasPriceProposal.decode(content.value) });
        case ProposalTypes.SetRewardCurve:
            return Object.assign(Object.assign({}, content), { value: CarbonSDK_1.Carbon.Liquiditypool.SetRewardCurveProposal.decode(content.value) });
        case ProposalTypes.SetRewardsWeights:
            return Object.assign(Object.assign({}, content), { value: CarbonSDK_1.Carbon.Liquiditypool.SetRewardsWeightsProposal.decode(content.value) });
        case ProposalTypes.SettlementPrice:
            return Object.assign(Object.assign({}, content), { value: CarbonSDK_1.Carbon.Pricing.SettlementPriceProposal.decode(content.value) });
        case ProposalTypes.UpdateMarket:
            return Object.assign(Object.assign({}, content), { value: CarbonSDK_1.Carbon.Market.UpdateMarketProposal.decode(content.value) });
        case ProposalTypes.ClientUpdateProposal:
            return Object.assign(Object.assign({}, content), { value: client_1.ClientUpdateProposal.decode(content.value) });
        case ProposalTypes.CreateAlliance:
            return Object.assign(Object.assign({}, content), { value: CarbonSDK_1.Carbon.Alliance.MsgCreateAllianceProposal.decode(content.value) });
        case ProposalTypes.UpdateAlliance:
            return Object.assign(Object.assign({}, content), { value: CarbonSDK_1.Carbon.Alliance.MsgUpdateAllianceProposal.decode(content.value) });
        case ProposalTypes.DeleteAlliance:
            return Object.assign(Object.assign({}, content), { value: CarbonSDK_1.Carbon.Alliance.MsgDeleteAllianceProposal.decode(content.value) });
        default:
            return exports.emptyProposal;
    }
};
exports.decodeContent = decodeContent;
